import { NO_HAPTIC_FEEDBACK } from "ui/src/utils/haptics/helpers";
export function useHapticFeedback() {
  return {
    hapticFeedback: NO_HAPTIC_FEEDBACK,
    hapticsEnabled: false,
    setHapticsEnabled: (_enabled) => {
    }
  };
}
